export const LEAD_STATUSES = [
  { id: "new", label: "New", cls: "border-neon/50 bg-neon/10 text-azure-deep" },
  { id: "contacted", label: "Contacted", cls: "border-amber-400/60 bg-amber-50 text-amber-700" },
  { id: "won", label: "Won", cls: "border-emerald-500/60 bg-emerald-50 text-emerald-700" },
  { id: "lost", label: "Lost", cls: "border-slate-300 bg-slate-100 text-slate-500" },
];

export function StatusPicker({ value, onChange, disabled, testid }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid} role="group" aria-label="Lead status">
      {LEAD_STATUSES.map((s) => {
        const active = s.id === value;
        return (
          <button
            key={s.id}
            type="button"
            disabled={disabled}
            onClick={() => !active && onChange(s.id)}
            data-testid={`${testid}-${s.id}`}
            aria-pressed={active}
            className={`rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.16em] transition-all duration-200 disabled:opacity-50 ${
              active ? s.cls : "border-slate-200 bg-white text-slate-400 hover:border-slate-400 hover:text-slate-600"
            }`}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
